<ion-button (click)="onHelpClick()" fill="clear" shape="round" class="auth-help fadeInRight delay-2s">
  <span>Help</span>
  <i class="far fa-question-circle auth-icon fadeIn delay-1s"></i>
</ion-button>
